import axios from "axios";
import { IOfficeAppliancesBrand } from "../type";

const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/OfficeApplianceBrand";

export const updateOfficeAppliancesBrand = async (
  updatedBrand: IOfficeAppliancesBrand
) => {
  const { data } = await axios.put(`${api_base_url}`, updatedBrand);
  return data;
};
